import { formatNumber, parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

export type TimeSeries = {
  id: number;
  owner_id?: number | null;
  owner_type?: string | null;
  category: number;
  window?: number | null;
  perm_values?: Record<string, any>;
  current_value?: number | null;
  full_start_date?: string | null;
  tmp_values?: Record<string, any>;
  current_date?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  source?: string | null;
  calculation_start_date?: string | null;
  created_at: string;
  updated_at: string;
};

export const time_series_columns: ColumnDef<TimeSeries>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "owner_id",
    header: "ID propriétaire",
  },
  {
    accessorKey: "owner_type",
    header: "Owner Type",
  },
  {
    accessorKey: "category",
    header: "Category",
  },
  {
    accessorKey: "window",
    header: "Window",
  },
  {
    accessorKey: "perm_values",
    header: "Permanent Values",
    cell: ({ row }) => {
      const value = row.getValue("perm_values");
      return value ? JSON.stringify(value) : "";
    },
  },
  {
    accessorKey: "current_value",
    header: "Current Value",
    cell: ({ row }) => {
      const value = row.getValue<number | null>("current_value");
      return value != null ? formatNumber(value) : "";
    },
  },
  {
    accessorKey: "full_start_date",
    header: "Full Start Date",
    cell: ({ row }) => {
      const value = row.getValue<string | null>("full_start_date");
      return value ? parseDate(value) : "";
    },
  },
  {
    accessorKey: "tmp_values",
    header: "Temporary Values",
    cell: ({ row }) => {
      const value = row.getValue("tmp_values");
      return value ? JSON.stringify(value) : "";
    },
  },
  {
    accessorKey: "current_date",
    header: "Current Date",
    cell: ({ row }) => {
      const value = row.getValue<string | null>("current_date");
      return value ? parseDate(value) : "";
    },
  },
  {
    accessorKey: "start_date",
    header: "Start Date",
    cell: ({ row }) => {
      const value = row.getValue<string | null>("start_date");
      return value ? parseDate(value) : "";
    },
  },
  {
    accessorKey: "end_date",
    header: "End Date",
    cell: ({ row }) => {
      const value = row.getValue<string | null>("end_date");
      return value ? parseDate(value) : "";
    },
  },
  {
    accessorKey: "source",
    header: "Source",
  },
  {
    accessorKey: "calculation_start_date",
    header: "Calculation Start Date",
    cell: ({ row }) => {
      const value = row.getValue<string | null>("calculation_start_date");
      return value ? parseDate(value) : "";
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => {
      return parseDate(row.getValue<string>("created_at"));
    },
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => {
      return parseDate(row.getValue<string>("updated_at"));
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
